import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import './styles/responsive/nav.css';
import './styles/responsive/components.css';
import './styles/redesign.css';
import App from './App';
import store from './store';
import { Web3Provider } from './config/web3Provider';
import { installSecureFetch } from './utils/e2e';

// Encrypt API request/response bodies end to end (see utils/e2e.js). Installed
// before the first render so every API call goes through it.
installSecureFetch();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Web3Provider>
      <App />
    </Web3Provider>
  </Provider>
);
